export default __webpack_public_path__ + "static/media/Internships.f6dbbc40.svg";